import { render, staticRenderFns } from "./PromotionInfo.vue?vue&type=template&id=05eb3eb6&scoped=true&"
import script from "./PromotionInfo.vue?vue&type=script&lang=ts&"
export * from "./PromotionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb3eb6",
  null
  
)

export default component.exports